// extracted by mini-css-extract-plugin
module.exports = {"block":"_2vITVW","block__linkRow":"_1kzTds"};